(function () {
  'use strict';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  }

  function initGuide(root) {
    if (!root || root.dataset.zvAppReady === 'true') return;
    root.dataset.zvAppReady = 'true';

    var jump = root.querySelector('[data-zv-app-jump]');
    var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-zv-app-nav]'));
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-zv-app-section]'));
    var backTop = root.querySelector('[data-zv-app-back-top]');
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('.zv-app-handleiding__faq details'));
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var headerSection = document.querySelector('.shopify-section-header');
    var hero = root.querySelector('.zv-app-handleiding__hero');
    var headerBackdropFrame = 0;

    function updateHeaderBackdrop() {
      if (!hero || !document.body.classList.contains('template-page-handleiding-zinvolt-app')) return;

      var cssHeaderHeight = parseFloat(
        window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 0;
      var measuredHeaderHeight = headerSection ? headerSection.getBoundingClientRect().height : 0;
      var headerHeight = Math.max(cssHeaderHeight, measuredHeaderHeight);
      var heroBottom = hero.getBoundingClientRect().bottom;

      document.body.classList.toggle('zv-app-header-past-hero', heroBottom <= headerHeight + 1);
    }

    function requestHeaderBackdropUpdate() {
      if (headerBackdropFrame) return;
      headerBackdropFrame = window.requestAnimationFrame(function () {
        headerBackdropFrame = 0;
        updateHeaderBackdrop();
      });
    }

    if (hero) {
      updateHeaderBackdrop();
      window.addEventListener('scroll', requestHeaderBackdropUpdate, { passive: true });
      window.addEventListener('resize', requestHeaderBackdropUpdate, { passive: true });
      window.addEventListener('load', requestHeaderBackdropUpdate, { once: true });
    }

    function findTarget(selector) {
      if (!selector || selector.charAt(0) !== '#') return null;
      try {
        return root.querySelector(selector) || document.querySelector(selector);
      } catch (error) {
        return null;
      }
    }

    function goTo(selector, updateUrl) {
      var target = findTarget(selector);
      if (!target) return;

      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      if (updateUrl !== false && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', selector);
      }
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link || !root.contains(link)) return;

      var selector = link.getAttribute('href');
      if (!findTarget(selector)) return;

      event.preventDefault();
      goTo(selector, true);
    });

    if (jump) {
      jump.addEventListener('change', function () {
        goTo(jump.value, true);
      });
    }

    function setActive(section) {
      if (!section || !section.id) return;
      var selector = '#' + section.id;

      navLinks.forEach(function (link) {
        if (link.getAttribute('href') === selector) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      if (jump) {
        var optionExists = Array.prototype.some.call(jump.options, function (option) {
          return option.value === selector;
        });
        if (optionExists) jump.value = selector;
      }
    }

    if ('IntersectionObserver' in window && sections.length) {
      var observer = new IntersectionObserver(function (entries) {
        var visible = entries
          .filter(function (entry) { return entry.isIntersecting; })
          .sort(function (a, b) {
            if (a.boundingClientRect.top !== b.boundingClientRect.top) {
              return Math.abs(a.boundingClientRect.top) - Math.abs(b.boundingClientRect.top);
            }
            return b.intersectionRatio - a.intersectionRatio;
          });

        if (visible.length) setActive(visible[0].target);
      }, {
        rootMargin: '-18% 0px -68% 0px',
        threshold: [0.01, 0.15, 0.35]
      });

      sections.forEach(function (section) {
        observer.observe(section);
      });
    } else if (sections[0]) {
      setActive(sections[0]);
    }

    function updateBackTop() {
      if (!backTop) return;
      backTop.classList.toggle('is-visible', window.scrollY > 760);
    }

    if (backTop) {
      updateBackTop();
      window.addEventListener('scroll', updateBackTop, { passive: true });
      backTop.addEventListener('click', function () {
        root.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }

    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        faqItems.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });

    if (window.location.hash && findTarget(window.location.hash)) {
      window.setTimeout(function () {
        goTo(window.location.hash, false);
      }, 80);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-zv-app-handleiding]').forEach(initGuide);
  }

  onReady(function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
